<template>
	<div id="CustomLutV2-rename-lut-modal" class="modal-new hidden">
		<span class="title">Rename LUT</span>
		<input v-model="name" type="text" name="folder-name" placeholder="Enter LUT name" />
		<div class="buttons-continer">
			<v-btn :disabled="processing" dark class="modal-btn --primary" @click="rename">Rename</v-btn>
			<button type="button" class="modal-btn --cancel" @click="close">Cancel</button>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import { stripTimestampAndExtension } from "@/assets/js/Utilities";

export default {
    data() {
        return {
            name: "",
            processing: false
        }
    },

    computed: {
        ...mapState('UserFilesCustomLuts', ['lutToRename']),
    },

    watch: {
        lutToRename(newValue) {
            this.name = stripTimestampAndExtension(newValue.name);
        }
    },

    methods: {
        async rename() {
            if (this.name == "") return;

            this.processing = true;
            const newFilename = `${this.name}.${Date.now()}.cube`;

            await this.$store.dispatch("UserFilesCustomLuts/rename", {
                name: newFilename,
                fileId: this.lutToRename.id
            });
            await this.$store.dispatch("UserFilesCustomLuts/index");

            lutify.blocks.forEach(block => {
                if (block.control !== "CustomLutV2") return;
                if (block.lut?.id !== this.lutToRename.id) return;

                block.lut.name = newFilename;
            })
            window._Adjustments.CustomLutV2.refreshAllBlocks();

            $(`#previews-list-container .list-item[data-lut-index="${this.lutToRename.id}"] .description`).text(this.name);

            const storeData = await customLutsStore.getItem(this.lutToRename.id);
            await customLutsStore.setItem(this.lutToRename.id, {
                ...storeData,
                name:newFilename
            })

            this.processing = false;

            this.close();
        },
        close() {
            window.UI.hideModal();
            window.UI.showModal(window.UI.modals.customLutV2.edit.el);
        },
    },
};
</script>

<style></style>
